@if (!statistics.alertsTabPagingComplete) {
  <div>
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    <p style="margin-top: 0.5rem;">
      {{ 'ALERTS_LOADED' | translate }}: {{ totalAlerts }}
    </p>
  </div>
}
@if (statistics.alertsTabPagingComplete && alertStatisticsData) {
  <div class="row">
    <div class="col stat-sidebar-col">
      <div>
        <alerts-by-location
          [locationAlerts]="alertStatisticsData.locationAlerts"
          >
        </alerts-by-location>
      </div>
      <div class="mt-3">
        <alerts-per-alert-type
          [alertTypeAlerts]="alertStatisticsData.alertsByTypes"
          >
        </alerts-per-alert-type>
      </div>
    </div>
    <div class="col stat-graphs-col">
      <div>
        <alerts-per-day
          [alertsByDays]="alertStatisticsData.alertsByDays"
          >
        </alerts-per-day>
      </div>
      <div class="mt-3">
        <alerts-per-hour
          [alertsByHours]="alertStatisticsData.alertsByHours"
        ></alerts-per-hour>
      </div>
      <div class="mt-3">
        <average-alert-durations
          [durations]="alertStatisticsData.averageDurations"
        ></average-alert-durations>
      </div>
      <div class="mt-3">
        <alerts-per-care-recipient
          [deviceAlerts]="alertStatisticsData.deviceAlerts"
        ></alerts-per-care-recipient>
      </div>
    </div>
  </div>
}
@if (statistics.alertsTabPagingComplete && !alertStatisticsData) {
  <div class="text-center mt-4">
    {{ 'NO_RESULTS' | translate }}
  </div>
}
